/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
/**
 * ReferenceResourceApi - axios parameter creator
 */
export const ReferenceResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get a reference by its code
     * @param {GetReferenceUntypedReferenceCodeEnum} referenceCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReferenceUntyped: async (
      referenceCode: GetReferenceUntypedReferenceCodeEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'referenceCode' is not null or undefined
      assertParamExists("getReferenceUntyped", "referenceCode", referenceCode)
      const localVarPath = `/reference/untyped/{referenceCode}`.replace(
        "{referenceCode}",
        encodeURIComponent(String(referenceCode))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ReferenceResourceApi - functional programming interface
 */
export const ReferenceResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReferenceResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get a reference by its code
     * @param {GetReferenceUntypedReferenceCodeEnum} referenceCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReferenceUntyped(
      referenceCode: GetReferenceUntypedReferenceCodeEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getReferenceUntyped(
        referenceCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ReferenceResourceApi.getReferenceUntyped"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ReferenceResourceApi - factory interface
 */
export const ReferenceResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ReferenceResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get a reference by its code
     * @param {ReferenceResourceApiGetReferenceUntypedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReferenceUntyped(
      requestParameters: ReferenceResourceApiGetReferenceUntypedRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<object> {
      return localVarFp
        .getReferenceUntyped(requestParameters.referenceCode, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getReferenceUntyped operation in ReferenceResourceApi.
 */
export interface ReferenceResourceApiGetReferenceUntypedRequest {
  readonly referenceCode: GetReferenceUntypedReferenceCodeEnum
}

/**
 * ReferenceResourceApi - object-oriented interface
 */
export class ReferenceResourceApi extends BaseAPI {
  /**
   *
   * @summary Get a reference by its code
   * @param {ReferenceResourceApiGetReferenceUntypedRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getReferenceUntyped(
    requestParameters: ReferenceResourceApiGetReferenceUntypedRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ReferenceResourceApiFp(this.configuration)
      .getReferenceUntyped(requestParameters.referenceCode, options)
      .then(request => request(this.axios, this.basePath))
  }
}

export const GetReferenceUntypedReferenceCodeEnum = {
  STATUT_JURIDIQUE: "STATUT_JURIDIQUE",
  SECTEUR_ACTIVITE: "SECTEUR_ACTIVITE",
  SECTEUR_ACTIVITE_2025: "SECTEUR_ACTIVITE_2025",
  STATUT_COOPERATIF: "STATUT_COOPERATIF",
  AGREMENT_ESUS: "AGREMENT_ESUS",
  RECOMMANDEUR: "RECOMMANDEUR",
  TYPE_RECOMMANDEUR: "TYPE_RECOMMANDEUR",
  PHASE_PROJET: "PHASE_PROJET",
  TERRITOIRE_FRAGILE: "TERRITOIRE_FRAGILE",
  OBJET_FINANCEMENT: "OBJET_FINANCEMENT",
  OBJET_PROJET: "OBJET_PROJET",
  FINALITE_SOCIETALE: "FINALITE_SOCIETALE",
  CODE_APE: "CODE_APE",
  CODE_APE_2025: "CODE_APE_2025",
  TYPE_ROLE: "TYPE_ROLE",
  CIVILITE: "CIVILITE",
  SITUATION_MATRIMONIALE: "SITUATION_MATRIMONIALE",
  SITUATION_PROFESSIONNELLE: "SITUATION_PROFESSIONNELLE",
  TYPE_REVENU: "TYPE_REVENU",
  NIVEAU_ETUDE: "NIVEAU_ETUDE",
  BENEFICIAIRE_MINIMA_SOCIAUX: "BENEFICIAIRE_MINIMA_SOCIAUX",
  ZONAGE_EPCI: "ZONAGE_EPCI",
  ZONAGE_QPV: "ZONAGE_QPV",
  MOTIF_ABANDON_ACCES_PLUS: "MOTIF_ABANDON_ACCES_PLUS",
  PRESCRIPTION_CAS_SORTIE: "PRESCRIPTION_CAS_SORTIE",
  PRECISION_NIVEAU_QUATRE: "PRECISION_NIVEAU_QUATRE",
  MILLESIME_ACCES_PLUS: "MILLESIME_ACCES_PLUS",
  FILIERE: "FILIERE",
  PRODUIT_INFORMATIONS: "PRODUIT_INFORMATIONS",
  TYPE_DECIDEUR_PRODUIT: "TYPE_DECIDEUR_PRODUIT",
  TYPE_CONTROLE_COMITE: "TYPE_CONTROLE_COMITE"
} as const
export type GetReferenceUntypedReferenceCodeEnum =
  (typeof GetReferenceUntypedReferenceCodeEnum)[keyof typeof GetReferenceUntypedReferenceCodeEnum]
